module.exports = __webpack_public_path__ + "static/img/sidebar_newlogo.0b4290d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sidebar_newlogo.png
// module id = iHa+
// module chunks = 1